<script setup lang="ts">
const props = defineProps({
	textButtonDefault: {
		type: String,
		required: true,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	onClick: {
		type: Function,
		required: true,
	},
});

const handleClick = () => {
	props.onClick();
};
</script>

<template>
	<button class="buttonDefaultWrapper" :disabled="disabled" @click="handleClick" :id="disabled ? 'buttonDefaultDisabled' : '' ">{{ textButtonDefault }}</button>
</template>

<style lang="scss">
    @use "./buttonDefault.scss";
</style>
